import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get video List
export const  getVideoList = createAsyncThunk(
  "getVideoList",
  async (
    { search, pageLimit, pageCount, sort_by, sort_direction },
    { rejectWithValue }
  ) => {
    try {
      let queryParams = [];

      if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
      if (pageCount) queryParams.push(`page=${pageCount}`);
      if (pageLimit) queryParams.push(`limit=${pageLimit}`);
      if (sort_by) queryParams.push(`sortBy=${sort_by}`);
      if (sort_direction) queryParams.push(`sortOrder=${sort_direction}`);

      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await AxiosApi.get(`/video/get-video${queryString}`);
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Something went wrong"
      );
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

// Create Edit video
export const createVideo = createAsyncThunk(
  "createVideo",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`/video/add-video`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Edit video
export const editVideo = createAsyncThunk(
  "editVideo",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`/video/update-video`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Delete video
export const deleteVideo = createAsyncThunk(
  "deleteVideo",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`/video/delete-video/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const videoSlice = createSlice({
  name: "video",
  initialState: initialStates,

  extraReducers: (builder) => {
    builder
      // get video list
      .addCase(getVideoList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVideoList.fulfilled, (state, action) => {
        state.loading = false;
        state.getVideoListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getVideoList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      //create video
      .addCase(createVideo.pending, (state) => {
        state.loading = true;
      })
      .addCase(createVideo.fulfilled, (state, action) => {
        state.loading = false;
        state.createVideoStatus.data = action.payload;
        state.error = false;
      })
      .addCase(createVideo.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      //Edit video
      .addCase(editVideo.pending, (state) => {
        state.loading = true;
      })
      .addCase(editVideo.fulfilled, (state, action) => {
        state.loading = false;
        state.editVideoStatus.data = action.payload;
        state.error = false;
      })
      .addCase(editVideo.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })

      // Delete video
      .addCase(deleteVideo.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteVideo.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteVideoStatus.data = action.payload;
        state.error = false;
      })
      .addCase(deleteVideo.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});

export const { setVideo } = videoSlice.actions;
export default videoSlice.reducer;
